document.addEventListener('DOMContentLoaded', function(){
    // Show transition
    viewLoaded();

    setTimeout(() => {
        // Validate Session Redirect
        validateSession();

        // ScrollBarEvents
        scrollBar();
        resetScrollBar();

        // Function Load Dinamic Content on Template
        customContentLs();

        // Show Status Content Viewed on Modulo 1
        validateStatusModulo();

        // Dinamic Content on Same View
        validateStep1Content();
        validateStep2Content();

        // Collapse Recursos Events Scripting
        collapseSubmenuRecursosEvents();
        
        // Collapse Recursos Mobile Events Scripting
        collapseSubmenuRecursosMobileEvents();

        // Submnenu Configuracion Mobile Events Scripting
        submenuConfiguracionMobileEvents();

        // Set saved fontsize iteration
        setTribu();
        setFontSize();
        setContrastRegion();

        // Enable tooltips
        enableTooltips();

        // Update Menu Module
        validateMenuModule();

        // Custom UI
        customizeUi();

        // Saved Navigation Links Data on Step 2
        toggleClassButtonsActive();

        // Default Load Carousels Controls
        defaultCarouselControls();

        // Set percent viewed by lesson
        calcProgress();

        // Dinamic footer
        dinamicFooter();

        // Dev Mode
        resetLocalStorage();
    }, 1500);
});

/********** Variables globales *********/
/** Content **/
// html
const html = document.querySelector('html');
// Body
const body = document.querySelector('body');
// Main
const main = document.querySelector('main');
// footer
const footer = document.querySelector('footer');

// Steps - Index Content
const step0 = document.querySelector('.step-0'); 
const step1 = document.querySelector('.step-1'); 
const step2 = document.querySelector('.step-2'); 

/* LECCION 1*/
const parentContentL1 = document.querySelector('.step-2 .leccion-1');
// Parent Content Lesson 1
const parentContentL1Activacion = document.querySelector('.step-2 .leccion-1 .activacion');
const parentContentL1Profundizacion = document.querySelector('.step-2 .leccion-1 .profundizacion');
const parentContentL1Dialogo = document.querySelector('.step-2 .leccion-1 .dialogo');
// Leccion 1 - Activacion Secciones
const listContentL1Activacion = document.querySelectorAll('.step-2 .leccion-1 .activacion .section');
// Leccion 1 - Profundizacion Secciones
const listContentL1Profundizacion = document.querySelectorAll('.step-2 .leccion-1 .profundizacion .section');
// Leccion 1 - Dialogo Secciones
const listContentL1Dialogo = document.querySelectorAll('.step-2 .leccion-1 .dialogo .section');
/**/

/* LECCION 2*/
const parentContentL2 = document.querySelector('.step-2 .leccion-2');
// Parent Content Lesson 2
const parentContentL2Activacion = document.querySelector('.step-2 .leccion-2 .activacion');
const parentContentL2Profundizacion = document.querySelector('.step-2 .leccion-2 .profundizacion');
const parentContentL2Dialogo = document.querySelector('.step-2 .leccion-2 .dialogo');
// Leccion 2 - Activacion Secciones
const listContentL2Activacion = document.querySelectorAll('.step-2 .leccion-2 .activacion .section');
// Leccion 2 - Profundizacion Secciones
const listContentL2Profundizacion = document.querySelectorAll('.step-2 .leccion-2 .profundizacion .section');
// Leccion 2 - Dialogo Secciones
const listContentL2Dialogo = document.querySelectorAll('.step-2 .leccion-2 .dialogo .section');
/**/

// Components
const navLesson = document.querySelector('.nav-lesson');

// Carousel Contents
const allCarouselContent = document.querySelectorAll('.carousel-content.carousel');
const allCarouselIndicators = document.querySelectorAll('.carousel-content.carousel .carousel-indicators button');
// Get all Carousel Items by Id
// L1 - Status
const carouselItemsL1Activacion = document.querySelectorAll('#carouselL1Activacion .carousel-inner .carousel-item');
const carouselItemsL1Profundizacion = document.querySelectorAll('#carouselL1Profundizacion .carousel-inner .carousel-item');
const carouselItemsL1Dialogo = document.querySelectorAll('#carouselL1Dialogo .carousel-inner .carousel-item');

// L2 - Status
const carouselItemsL2Activacion = document.querySelectorAll('#carouselL2Activacion .carousel-inner .carousel-item');
const carouselItemsL2Profundizacion = document.querySelectorAll('#carouselL2Profundizacion .carousel-inner .carousel-item');
const carouselItemsL2Dialogo = document.querySelectorAll('#carouselL2Dialogo .carousel-inner .carousel-item');

/********** DOM Scripting *********/
// Debug LocalStorage
function debugLocalStorage(){
    Object.keys(localStorage).forEach(function (key){
        console.table(`-------\nLocal Storage -> Key: ${key} | Value: ${localStorage.getItem(key)}\n-------`);
    });
}

// Reset LocalStorage
function resetLocalStorage(){
    const buttons = document.querySelectorAll('.resetLocalStorage');

    buttons.forEach(function(button){
        button.addEventListener('click', function(){
            deleteDataSession();
        });
    });
}

// Get Instance Collapse Tribus
function collapseTribus(){
    const collapseSubmenuModule = new bootstrap.Collapse('#collapseSelectTribu', {
        toggle: false,
        hide: true
    });

    return collapseSubmenuModule;
}

// Get Instance Collapse Sumbmenu Module 
function collapseSubmenuModule(){
    const submenuModule = new bootstrap.Collapse('#collapseSubmenuModule', {
        toggle: false,
        hide: true
    });

    return submenuModule;
}

// Events Collapse Recursos
function collapseSubmenuRecursosEvents(){
    // const btnSubmenuRecursos = document.querySelector('#btn-submenu-recursos');
    const textIconPicker = document.querySelector('#icon-picker-recursos');

    const collapseSubmenuRecursos = document.querySelector('#collapseSubmenuModule');
    const instanceCollapse = new bootstrap.Collapse(`#${collapseSubmenuRecursos.id}`, {
        toggle: false,
        hide: true
    });

    // btnSubmenuRecursos.addEventListener('mouseover', function(){
    //     collapseSubmenuModule().show();
    // });
    // collapseSubmenuRecursos.addEventListener('mouseleave', function(){
    //     collapseSubmenuModule().hide();
    //     btnSubmenuRecursos.classList.remove('active');
    // });

    // Get text icon picker

    // Modal Créditos
    const modalContentCreditos = document.querySelector('#modal-creditos');
    modalContentCreditos.addEventListener('show.bs.modal', function(event){
        instanceCollapse.hide();
    });
    
    collapseSubmenuRecursos.addEventListener('show.bs.collapse', function(event){
        // btnSubmenuRecursos.classList.add('active');
        textIconPicker.innerHTML = '▴';
    });
    collapseSubmenuRecursos.addEventListener('hide.bs.collapse', function(event){
        textIconPicker.innerHTML = '▾';
        // btnSubmenuRecursos.classList.remove('active');
    });
}

// Get Instance Collapse Sumbmenu Module Mobile
function collapseSubmenuModuleMobile(){
    const submenuModule = new bootstrap.Collapse('#collapseSubmenuModuleMobile', {
        toggle: false,
        hide: true
    });

    return submenuModule;
}

// Events Collapse Sumbmenu Module Mobile
function collapseSubmenuRecursosMobileEvents(){
    const collapseSubmenuRecursosMobile = document.querySelector('#collapseSubmenuModuleMobile');
    const instanceCollapse = new bootstrap.Collapse(`#${collapseSubmenuRecursosMobile.id}`, {
        toggle: false,
        hide: true
    });

    // Modal Créditos
    const modalContentCreditos = document.querySelector('#modal-creditos');
    modalContentCreditos.addEventListener('show.bs.modal', function(event){
        instanceCollapse.hide();
    });

    collapseSubmenuRecursosMobile.addEventListener('show.bs.collapse', function(event){
        body.classList.add('stop-scrolling');
    });
    collapseSubmenuRecursosMobile.addEventListener('hide.bs.collapse', function(event){
        body.classList.remove('stop-scrolling');
    });
}

// Events Collapse Sumbmenu Configuracion Mobile
function submenuConfiguracionMobileEvents(){
    const collapseSubmenuConfiguracionMobile = document.querySelector('#buttonSubmenuConfiguracionMobile');
    const contentSubmenu = document.querySelector('#custom-ui');
    const textIconPicker = document.querySelector('#icon-picker-configuracion-mobile');
    
    collapseSubmenuConfiguracionMobile.addEventListener('click', function(event){
        if(contentSubmenu.classList.contains('active')){
            textIconPicker.innerHTML = '▼';
            contentSubmenu.className = '';
            contentSubmenu.classList.add('d-none', 'd-sm-none', 'd-md-flex',);
        }
        else{
            textIconPicker.innerHTML = '▲';
            contentSubmenu.className = '';
            contentSubmenu.classList.add('d-flex', 'd-sm-flex', 'd-md-flex', 'active', 'bounce-in-fwd');
        }
    });
}

// Reset CustomUi Bar Mobile
function resetCustomUiMobile(){
    const contentSubmenu = document.querySelector('#custom-ui');
    const textIconPicker = document.querySelector('#icon-picker-configuracion-mobile');

    textIconPicker.innerHTML = '▼';
    contentSubmenu.className = '';
    contentSubmenu.classList.add('d-none', 'd-sm-none', 'd-md-flex',);    
}

/****/

// Save LocalStorage
function saveDataSession(metaTag, value){
    return localStorage.setItem(metaTag, value);
}

// Get Values from LocalStorage
function getValueSession(key){
    return localStorage.getItem(key);
}

// Delete Specific LocalStorage item
function deleteDataItem(key){
    localStorage.removeItem(key);
}

// Delete LocalStorage
function deleteDataSession(){
    localStorage.clear();
    location.reload();
    // debugLocalStorage();
}

// Validate Previous Session
function validateSession(){
    if(getValueSession('M6_Subtema')){
        validateStepLoad(step2);
        validateStep2LastVisited();
    }
    else if(getValueSession('M6_Tribu')){
        validateStepLoad(step1);
    }
    else{
        validateStepLoad(step0);
        validateInit();
    }
}

// Validate whats load when the page reload -> Saved Session
// STEPS - Default validateStepLoad(step1);
function validateStepLoad(stepId){
    const steps = document.querySelectorAll('[data-element="step-content"]');

    steps.forEach(function(step){
        if(step === stepId){
            step.classList.remove('d-none');
        }
        else{
            step.classList.add('d-none');
        }
    });
    
    // Pause Media Video
    stopVideo();

    // Pause Media Audio
    stopAudio();

    // Reset Speech Audio 
    resetAudioSpeech();

    // Reset customUi Mobile
    resetCustomUiMobile();

    // Reset scroll - Elements
    resetScrollElements();
}

// Validate Form Inpunt on the Intro Of the Project
function validateInit() {
    const buttonInit = document.querySelector('[data-validate="tribu-selected"]');
    
    const msnTribu = document.querySelector('#validate-input-tribu');

    // Validation for tribu
    const formStep0 = document.querySelector('#form-step-0');
    const titleRegion = document.querySelector('#nombre-region');
    const descriptionRegion = document.querySelector('#region-descripcion');
    // const inputRegion = document.querySelector('#input-region');
    const selectTribu = document.querySelector('#select-tribu');

    const regionesMapa = document.querySelectorAll('.region-vector-mapa');

    function resetFormContent(){
        titleRegion.classList.add('d-none');

        descriptionRegion.classList.add('d-none');

        selectTribu.classList.add('d-none');

        msnTribu.classList.add('d-none');

        buttonInit.classList.add('d-none');
    }

    regionesMapa.forEach(function(item){
        item.addEventListener('click', function(){
            resetFormContent();
            formStep0.reset();

            saveDataSession('M6_Region', `${item.dataset.region}`);
            // inputRegion.value = `${item.dataset.region}`;
            toggleRegionClass();

            setTimeout(() => {
                logTribus(item.dataset.bsTitle);
                
                titleRegion.classList.remove('d-none');
                titleRegion.classList.add('slide-in-blurred-bottom');
                
                descriptionRegion.classList.remove('d-none');
                descriptionRegion.classList.add('bounce-in-fwd');
                
                selectTribu.classList.remove('d-none');
                selectTribu.classList.add('slide-in-blurred-top', 'delay_1');
            }, 0);

            setTimeout(() => {
                const sectionTop = footer.offsetTop;
    
                window.scrollTo({
                    top: sectionTop,
                    behavior: "smooth"
                });
            }, 2000);
            
        }); 
    });

    selectTribu.addEventListener('blur', function(){
        if(selectTribu.value !== ''){
            msnTribu.textContent = '';  
            msnTribu.classList.add('d-none');
            
            return true;
        }
        else{
            msnTribu.textContent = 'Selecciona un elemento de la lista';
            msnTribu.classList.remove('d-none');
        }
    });

    buttonInit.addEventListener('click', function(){
        if(selectTribu.value !== ''){
            // LocalStorage Save Variable
            resetScrollBar();
            validateStepLoad(step1);
    
            msnTribu.textContent = '';  
            msnTribu.classList.add('d-none');
    
            // saveDataSession('M6_Region', `${inputRegion.value}`);
            saveDataSession('M6_Tribu', selectTribu.value);
            saveDataSession('M6_Modulo', 'Módulo 6');
    
            // Update Tribu Head
            setTribu();

            // Function Load Dinamic Content on Template
            customContentLs();
    
            // Update Menu Module
            validateMenuModule();
    
            // Show transition view loaded
            viewLoaded();
    
            // Dinamic footer
            dinamicFooter();
        }
        else{
            msnTribu.textContent = 'Selecciona un elemento de la lista';
            msnTribu.classList.remove('d-none');
        }
    });

    async function logTribus(filter){
        const response = await fetch("./local-API/tribus.json");
        const query = await response.json();
        const queryTribus = Object.keys(query[filter].tribus);

        const queryNombre = filter;
        const queryDescripcion = query[filter].descripcion;

        titleRegion.textContent = `${queryNombre}`;
        descriptionRegion.textContent = `${queryDescripcion}`;
        
        // console.log(Object.keys(query));
        // console.log(Object.values(query));
        // console.log(queryTribus);

        while (selectTribu.childElementCount > 1) {
            selectTribu.removeChild(selectTribu.lastChild);
        }

        for (const key in queryTribus){
            const value = `${Object.values(queryTribus)[key]}`;
            const optionTribu = document.createElement('OPTION');
            optionTribu.setAttribute('value', `${value}`);
            optionTribu.dataset.key = `${key}`;
            optionTribu.textContent = `${value}`;
            selectTribu.appendChild(optionTribu);
        }

        login();
    }

    function login(){
        selectTribu.addEventListener("change", function(){
            if(selectTribu.value !== ''){
                buttonInit.classList.remove('d-none');
                buttonInit.classList.add('slide-in-blurred-top');

                msnTribu.textContent = '';  
                msnTribu.classList.add('d-none');
            }
            else{
                return false;
            }
        });

    }

}

// STEP-1 VALIDATION
// Show Status Content Viewed on Modulo 1
function validateStatusModulo(){
    // Get values of progress located in LocalStorage
    const getStatusL1Activacion = `${getValueSession('M6_StatusL1Activacion')}`;
    const getStatusL1Profundizacion = `${getValueSession('M6_StatusL1Profundizacion')}`;
    const getStatusL1Dialogo = `${getValueSession('M6_StatusL1Dialogo')}`;

    const getStatusL2Activacion = `${getValueSession('M6_StatusL2Activacion')}`;
    const getStatusL2Profundizacion = `${getValueSession('M6_StatusL2Profundizacion')}`;
    const getStatusL2Dialogo = `${getValueSession('M6_StatusL2Dialogo')}`;

    // Get all icons Status
    // Lección 1
    const iconL1Completed = document.querySelectorAll('.icon-l1-completed');
    const iconStatusL1Activacion = document.querySelectorAll('.icon-status-l1-activacion');
    const iconStatusL1Profundizacion = document.querySelectorAll('.icon-status-l1-profundizacion');
    const iconStatusL1Dialogo = document.querySelectorAll('.icon-status-l1-dialogo');

    // Lección 2
    const iconL2Completed = document.querySelectorAll('.icon-l2-completed');
    const iconStatusL2Activacion = document.querySelectorAll('.icon-status-l2-activacion');
    const iconStatusL2Profundizacion = document.querySelectorAll('.icon-status-l2-profundizacion');
    const iconStatusL2Dialogo = document.querySelectorAll('.icon-status-l2-dialogo');

    // Tapic Validation
    function validateTopicStatus(topic, iconStatusTopic, targetList){
        if(topic === 'completado'){
            // array.forEach(icon => {
            // });

            iconStatusTopic.forEach(function(icon){
                icon.parentNode.classList.add('active');

                icon.classList.remove('icon-dash-circle');
                icon.classList.add('icon-check');
            });

            targetList.forEach(function(item){
                item.dataset.itemStatus = "completo";
            });
        }
        else{
            iconStatusTopic.forEach(function(icon){
                icon.parentNode.classList.add('remove');

                icon.classList.remove('icon-check');
                icon.classList.add('icon-dash-circle');
            });
        }
    }
    // Lección 1
    validateTopicStatus(getStatusL1Activacion, iconStatusL1Activacion, carouselItemsL1Activacion);
    validateTopicStatus(getStatusL1Profundizacion, iconStatusL1Profundizacion, carouselItemsL1Profundizacion);
    validateTopicStatus(getStatusL1Dialogo, iconStatusL1Dialogo, carouselItemsL1Dialogo);

    // Lección 2
    validateTopicStatus(getStatusL2Activacion, iconStatusL2Activacion, carouselItemsL2Activacion);
    validateTopicStatus(getStatusL2Profundizacion, iconStatusL2Profundizacion, carouselItemsL2Profundizacion);
    validateTopicStatus(getStatusL2Dialogo, iconStatusL2Dialogo, carouselItemsL2Dialogo);


    // lesson Validation
    function validateLessonStatus(topic1, topic2, topic3, iconStatusLesson){
        if(topic1 === 'completado' && topic2 === 'completado' && topic3 === 'completado'){
            iconStatusLesson.forEach(function(icon){
                icon.classList.remove('d-none');
            });
        }
        else{
            iconStatusLesson.forEach(function(icon){
                icon.classList.add('d-none');
            });
        }
    }
    // Lección 1
    validateLessonStatus(getStatusL1Activacion, getStatusL1Profundizacion, getStatusL1Dialogo, iconL1Completed);
    // Lección 2
    validateLessonStatus(getStatusL2Activacion, getStatusL2Profundizacion, getStatusL2Dialogo, iconL2Completed);

    // debugLocalStorage();
}

function validateStep1Content(){
    const buttons = document.querySelectorAll('[data-element="button-to-step-1"]');

    buttons.forEach(function(button){
        button.addEventListener('click', function(event){
            // Reset the event button las clicked render content
            saveDataSession('M6_LastSubtopicVisited', '');
            
            // Change value lesson title id
            saveDataSession('M6_Leccion', 'Inicio');

            // Reset the Topic title
            saveDataSession('M6_Tema', 'Ninguno');

            // Reset Home Path
            saveDataSession('M6_Subtema', '');

            if(button.dataset.element === 'button-to-step-1'){
                // Toggle Header
                toggleHeader();

                // Hide all Toast
                hideToast();

                // Show Status Content Viewed on Modulo 1
                validateStatusModulo();

                // Hide Steps 0,1 and show Step 2
                // resetScrollBar();
                validateStepLoad(step1);

                // Function Load Dinamic Content on Template
                customContentLs();

                // Update Menu Module view of STEP 2
                validateMenuModule();

                // Hide Collapse Submenu Module
                collapseSubmenuModule().hide();

                // Hide Collapse Submenu Module Mobile
                collapseSubmenuModuleMobile().hide();

                // Show transition view loaded
                viewLoaded();

                // Saved Navigation Links Data on Step 1
                toggleClassButtonsActive();

                // Dinamic footer
                dinamicFooter();

                // Redirect to table of contents
                setTimeout(() => {
                    const sectionTop = document.querySelector('#table-of-contents').offsetTop;
        
                    window.scrollTo({
                        top: sectionTop,
                        behavior: "smooth"
                    });
                }, 0);
            }
            else{
                // Hide All Steps
                validateStepLoad('hide');
            }
        });
    });
}

// STEP-2 VALIDATION
// Validate active item on STEP With Routes and Interactions
function validateStep2LastVisited(){
    switchContentStep2(`${getValueSession('M6_LastSubtopicVisited')}`, `${getValueSession('M6_Leccion')}`, `${getValueSession('M6_Tema')}`);
    // debugLocalStorage();
}

// Switch content on Step 2
function switchContentStep2(lastVisited, lesson, topic){
    toggleHeader();

    switch (lesson) {
        /* LECCION 1 */
        case 'Lección 1':
            parentContentL1.classList.remove('d-none');
            parentContentL2.classList.add('d-none');

            // Hide all Toast
            hideToast();

            switch (topic) {
                case 'l1-activacion':
                    // Show content
                    parentContentL1Activacion.classList.remove('d-none');
                    parentContentL1Profundizacion.classList.add('d-none');
                    parentContentL1Dialogo.classList.add('d-none');
        
                    listContentL1Activacion.forEach(function(section){
                        let getDataLoad = section.dataset.load;
                        let getDataFetch = section.dataset.fetch;  
        
                        section.innerHTML = '';
                        fetchContent(`./content/${lastVisited}${getDataLoad}.html`, getDataFetch, `.leccion-1 .activacion .section-${getDataLoad}`); 
                    });
        
                    
                    // Load Scripting - Components Interactive - Profundizacion
                    setTimeout(() => {
                        // Nav Progress Interactions
                        progressComponent();
                        // Control Multimedia Nodo
                        // Show toast 
                        toggleToast('carouselL1Activacion');
                        // Set percent viewed by lesson
                        calcProgress();
                    }, 1500);

                    break;

                case 'l1-profundizacion':
                    // Show content
                    parentContentL1Activacion.classList.add('d-none');
                    parentContentL1Profundizacion.classList.remove('d-none');
                    parentContentL1Dialogo.classList.add('d-none');
        
                    listContentL1Profundizacion.forEach(function(section){
                        let getDataLoad = section.dataset.load;
                        let getDataFetch = section.dataset.fetch;  
        
                        section.innerHTML = '';
                        fetchContent(`./content/${lastVisited}${getDataLoad}.html`, getDataFetch, `.leccion-1 .profundizacion .section-${getDataLoad}`);  
                    });
        
                    
                    // Load Scripting - Components Interactive - Profundizacion                    
                    setTimeout(() => {
                        // Nav Progress Interactions
                        progressComponent();
                        // FlexSwitch -> Content
                        flexSwitchValidateL1Profundizacion();
                        // Control Multimedia Nodo
                        controlMultimediaL1Profundizacion();
                        // Validate Form
                        validateFormL1();
                        // Validate Form LocalStorage -> Toast
                        validateLsFormL1();
                        // Set percent viewed by lesson
                        calcProgress();
                    }, 1500);
                    
                    break;

                case 'l1-dialogo':
                    parentContentL1Activacion.classList.add('d-none');
                    parentContentL1Profundizacion.classList.add('d-none');
                    parentContentL1Dialogo.classList.remove('d-none');
        
                    listContentL1Dialogo.forEach(function(section){
                        let getDataLoad = section.dataset.load;
                        let getDataFetch = section.dataset.fetch;  
        
                        section.innerHTML = '';
                        fetchContent(`./content/${lastVisited}${getDataLoad}.html`, getDataFetch, `.leccion-1 .dialogo .section-${getDataLoad}`); 
                    });

                    // Load Scripting - Components Interactive - Profundizacion
                    setTimeout(() => {
                        // Nav Progress Interactions
                        progressComponent();
                        // Show toast 
                        toggleToast('carouselL1Dialogo');
                        // Set percent viewed by lesson
                        calcProgress();
                    }, 1500);


                    break;

                // By default
                default:
                    parentContentL1Activacion.classList.add('d-none');
                    parentContentL1Profundizacion.classList.add('d-none');
                    parentContentL1Dialogo.classList.add('d-none');
                    break;
            }
            break;

        /* LECCION 2 */
        case 'Lección 2':
            parentContentL1.classList.add('d-none');
            parentContentL2.classList.remove('d-none');

            // Hide all Toast
            hideToast();

            switch (topic) {
                case 'l2-activacion':
                    // Show content
                    parentContentL2Activacion.classList.remove('d-none');
                    parentContentL2Profundizacion.classList.add('d-none');
                    parentContentL2Dialogo.classList.add('d-none');
        
                    listContentL2Activacion.forEach(function(section){
                        let getDataLoad = section.dataset.load;
                        let getDataFetch = section.dataset.fetch;  
        
                        section.innerHTML = '';
                        fetchContent(`./content/${lastVisited}${getDataLoad}.html`, getDataFetch, `.leccion-2 .activacion .section-${getDataLoad}`); 
                    });
        
                    // Load Scripting - Components Interactive - Profundizacion
                    setTimeout(() => {
                        // Nav Progress Interactions
                        progressComponent();
                        // FlexSwitch -> Content
                        // Show toast 
                        toggleToast('carouselL2Activacion');
                        // Set percent viewed by lesson
                        calcProgress();
                    }, 1500);

                    break;

                case 'l2-profundizacion':
                    // Show content
                    parentContentL2Activacion.classList.add('d-none');
                    parentContentL2Profundizacion.classList.remove('d-none');
                    parentContentL2Dialogo.classList.add('d-none');
        
                    listContentL2Profundizacion.forEach(function(section){
                        let getDataLoad = section.dataset.load;
                        let getDataFetch = section.dataset.fetch;  
        
                        section.innerHTML = '';
                        fetchContent(`./content/${lastVisited}${getDataLoad}.html`, getDataFetch, `.leccion-2 .profundizacion .section-${getDataLoad}`);  
                    });
        
                    // Load Scripting - Components Interactive - Profundizacion           
                    setTimeout(() => {
                        // Nav Progress Interactions
                        progressComponent();
                        // FlexSwitch -> Content
                        flexSwitchValidateL2Profundizacion();
                        // Control Multimedia Nodo
                        controlMultimediaL2Profundizacion();
                        // Validate Form
                        validateFormL2();
                        // Validate Form LocalStorage -> Toast
                        validateLsFormL2();
                        // Set percent viewed by lesson
                        calcProgress();
                    }, 1500);
                    
                    break;

                case 'l2-dialogo':
                    parentContentL2Activacion.classList.add('d-none');
                    parentContentL2Profundizacion.classList.add('d-none');
                    parentContentL2Dialogo.classList.remove('d-none');
        
                    listContentL2Dialogo.forEach(function(section){
                        let getDataLoad = section.dataset.load;
                        let getDataFetch = section.dataset.fetch;  
        
                        section.innerHTML = '';
                        fetchContent(`./content/${lastVisited}${getDataLoad}.html`, getDataFetch, `.leccion-2 .dialogo .section-${getDataLoad}`); 
                    });

                    // Load Scripting - Components Interactive - Profundizacion
                    setTimeout(() => {
                        // Nav Progress Interactions
                        progressComponent();
                        // Show toast 
                        toggleToast('carouselL2Dialogo');
                        // Set percent viewed by lesson
                        calcProgress();
                    }, 1500);

                    break;

                // By default
                default:
                    parentContentL2Activacion.classList.add('d-none');
                    parentContentL2Profundizacion.classList.add('d-none');
                    parentContentL2Dialogo.classList.add('d-none');
                    break;
            }
            break;

        default:
            parentContentL1.classList.add('d-none');
            parentContentL2.classList.add('d-none');
            break;
    }
}

// Validate content to load on STEP 2 -> Content Lesson
function validateStep2Content(){
    const buttons = document.querySelectorAll('[data-element="button-to-step-2"]');

    buttons.forEach(function(button){
        
        button.addEventListener('click', function(event){
            // Remove class active of all buttons
            buttons.forEach(function(button){
                button.classList.remove('active');
            });

            // Save the event button las clicked render content
            const getContent = event.target.dataset.content;
            saveDataSession('M6_LastSubtopicVisited', getContent);
            
            // Save the lesson title id
            const getLesson = event.target.dataset.lesson;
            saveDataSession('M6_Leccion', getLesson);

            // Save the Topic title
            const getTopic = event.target.dataset.topic;
            saveDataSession('M6_Tema', getTopic);

            // Save the subtopic title
            const getSubtopic = event.target.title;
            saveDataSession('M6_Subtema', getSubtopic);

            // Validate Click
            if(button.dataset.element === 'button-to-step-2'){
                // Toggle Header
                toggleHeader();

                // Hide Steps 0,1 and show Step 2
                resetScrollBar();
                validateStepLoad(step2);

                // Function Load Dinamic Content on Template
                customContentLs();
                
                // Update Menu Module view of STEP 2
                validateMenuModule();
                
                // Load content
                switchContentStep2(getContent, getLesson, getTopic);
                
                // Hide Collapse Submenu Module
                collapseSubmenuModule().hide();

                // Hide Collapse Submenu Module Mobile
                collapseSubmenuModuleMobile().hide();

                // Show transition view loaded
                viewLoaded();

                // Saved Navigation Links Data on Step 2
                toggleClassButtonsActive();

                // Dinamic footer
                dinamicFooter();
            }
            else{
                // Hide All Steps
                validateStepLoad('hide');
            }

            // debugLocalStorage();
        });

        
    });
}

// Validate Class Active on Step 2
function toggleClassButtonsActive(){
    const getLesson = `${getValueSession('M6_Leccion')}`;
    const getTopic = `${getValueSession('M6_Tema')}`;

    // Buttons with data-topic l1-
    const btnsHome = document.querySelectorAll('[data-element="button-to-step-1"]');

    // Buttons with data-topic l1-
    const btnsL1Activacion = document.querySelectorAll('[data-topic="l1-activacion"]');
    const btnsL1Profundizacion = document.querySelectorAll('[data-topic="l1-profundizacion"]');
    const btnsL1Dialogo = document.querySelectorAll('[data-topic="l1-dialogo"]');

    // Buttons with data-topic l2-
    const btnsL2Activacion = document.querySelectorAll('[data-topic="l2-activacion"]');
    const btnsL2Profundizacion = document.querySelectorAll('[data-topic="l2-profundizacion"]');
    const btnsL2Dialogo = document.querySelectorAll('[data-topic="l2-dialogo"]');

    switch (getLesson) {
        case 'Inicio':
            // For home buttons
            btnsHome.forEach(function(button){
                button.classList.add('active');
            });

            // For lesson 1 - Reset
            btnsL1Activacion.forEach(function(button){
                button.classList.remove('active');
            });
            btnsL1Profundizacion.forEach(function(button){
                button.classList.remove('active');
            });
            btnsL1Dialogo.forEach(function(button){
                button.classList.remove('active');
            });

            // For lesson 2 - Reset
            btnsL2Activacion.forEach(function(button){
                button.classList.remove('active');
            });
            btnsL2Profundizacion.forEach(function(button){
                button.classList.remove('active');
            });
            btnsL2Dialogo.forEach(function(button){
                button.classList.remove('active');
            });
            break;

        case 'Lección 1':
            // For home buttons
            btnsHome.forEach(function(button){
                button.classList.remove('active');
            });

            if(getTopic === 'l1-activacion'){
                btnsL1Activacion.forEach(function(button){
                    button.classList.add('active');
                });
            }
            else if(getTopic === 'l1-profundizacion'){
                btnsL1Profundizacion.forEach(function(button){
                    button.classList.add('active');
                });
            }
            else{
                btnsL1Dialogo.forEach(function(button){
                    button.classList.add('active');
                });
            }
            break;

        case 'Lección 2':
            // For home buttons
            btnsHome.forEach(function(button){
                button.classList.remove('active');
            });

            if(getTopic === 'l2-activacion'){
                btnsL2Activacion.forEach(function(button){
                    button.classList.add('active');
                });
            }
            else if(getTopic === 'l2-profundizacion'){
                btnsL2Profundizacion.forEach(function(button){
                    button.classList.add('active');
                });
            }
            else{
                btnsL2Dialogo.forEach(function(button){
                    button.classList.add('active');
                });
            }
            break;

        default:
            break;
    }
}

/** CUSTOM UI **/
// Custom FontSize - Toggler
function customizeUi(){
    // Custom UI
    const customUiIdioma = document.querySelector('#custom-ui-idioma');

    const customUiAudioOn = document.querySelector('#custom-ui-audio-on');
    const customUiAudioOff = document.querySelector('#custom-ui-audio-off');
    
    const customUiFontSize = document.querySelector('#custom-ui-font-size');
    
    const customUiInstructivo = document.querySelector('#custom-ui-instructivo');
    
    const customUiContraste = document.querySelector('#custom-ui-contraste');
    
    const customUiFullScreen = document.querySelector('#custom-ui-full-screen');
    const customUiFullScreenExit = document.querySelector('#custom-ui-full-screen-exit');
    
    // let incrementConfig = 0;
    let incrementConfig = `${getValueSession('M6_FontSizeId')}`;
    let increment = parseInt(incrementConfig, 10);
    
    // Custom UI - Audio
    function speechQuery(context, state){
        const synth = window.speechSynthesis;
        
        const templateString = new SpeechSynthesisUtterance();
        templateString.lang = 'es-MX';
        
        switch (state) {
            case 'speak':
                // synth.speak(templateString);  
                // Set content to read and format the finally content without spaces and breaklines
                const content = document.querySelector(`${context}`).textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
                const formattedContent = content.replace(/\s+/g, ' ');
        
                // Get the number of words from textContent
                const numberOfWords = Math.ceil(formattedContent.split(' ').length/500);

                // Array to save the sentences
                let listOfSentences = [] // This is our arrray.
                for(let i = 0; i < numberOfWords; i++){
                    listOfSentences[i] = [];
                }

                //  Create a 2D array
                let wordCount = 0; 
                for (let x = 0; x < Math.ceil(formattedContent.split(' ').length/500); x++) {
                    for (let j = 0; j < 500; j++) {
                        listOfSentences[x][j] = formattedContent.split(' ')[wordCount++];
                    }

                    // This run read event
                    templateString.text = listOfSentences[x].join(' ');
                    synth.speak(templateString);

                    // Debug
                    // console.log(wordCount);
                    // console.log(listOfSentences);
                    // console.log(formattedContent);
                }

                templateString.addEventListener('end', function(){
                    customUiAudioOn.classList.add('d-none');
                    customUiAudioOff.classList.remove('d-none');
                });

                break;

            case 'cancel':
                synth.cancel(); 
                break;
        
            default:
                break;
        };

    }
    
    function switchContentForSpeech(){
        const getTopic = `${getValueSession('M6_Tema')}`;
        // console.log(getTopic);

        if(getTopic === 'Ninguno'){
            return '.step-1';
        }
        // Lección 1
        else if(getTopic === 'l1-activacion'){
            return '.step-2 .leccion-1 .activacion .carousel .carousel-inner .carousel-item.active';
        }
        else if(getTopic === 'l1-profundizacion'){
            return '.step-2 .leccion-1 .profundizacion .carousel .carousel-inner .carousel-item.active';
        }
        else if(getTopic === 'l1-dialogo'){
            return '.step-2 .leccion-1 .dialogo .carousel .carousel-inner .carousel-item.active';
        }

        // Lección 2
        else if(getTopic === 'l2-activacion'){
            return '.step-2 .leccion-2 .activacion .carousel .carousel-inner .carousel-item.active';
        }
        else if(getTopic === 'l2-profundizacion'){
            return '.step-2 .leccion-2 .profundizacion .carousel .carousel-inner .carousel-item.active';
        }
        else if(getTopic === 'l2-dialogo'){
            return '.step-2 .leccion-2 .dialogo .carousel .carousel-inner .carousel-item.active';
        }

        else{
            return false;
        }
    }

    customUiAudioOff.addEventListener('click', function(){
        customUiAudioOff.classList.add('d-none');
        customUiAudioOn.classList.remove('d-none');
        
        speechQuery(switchContentForSpeech(), 'speak');
    });
    
    customUiAudioOn.addEventListener('click', function(){
        customUiAudioOn.classList.add('d-none');
        customUiAudioOff.classList.remove('d-none');

        speechQuery(switchContentForSpeech(), 'cancel');
    });
    

    // Custom UI - FontSize
    customUiFontSize.addEventListener('click', function(){
        increment++;
        // console.log(increment);

        if(increment === 1){
            html.className = '';
            html.classList.add('font-size-medium');
        }
        else if(increment === 2){
            html.className = '';
            html.classList.add('font-size-big');
        }
        else if(increment === 3){
            html.className = '';
            html.classList.add('font-size-bigger');
        }
        else{
            html.className = '';
            html.classList.add('font-size-default');
            
            increment = 0;
        }

        saveDataSession('M6_FontSize', html.className);
        saveDataSession('M6_FontSizeId', increment);
        
        // debugLocalStorage();
    });

    // Custom UI - Instructivo
    const modalContentInstructivo = document.querySelector('#modal-instrucciones');
    const modalInstructivo = new bootstrap.Modal('#modal-instrucciones', {
        keyboard: true,
    });
    customUiInstructivo.addEventListener('click', function(){
        modalInstructivo.show();
    });
    modalContentInstructivo.addEventListener('hidden.bs.modal', event => {
        stopVideo();
    });

    // Custom UI - Contraste
    customUiContraste.addEventListener('click', function(){
        if(body.classList.contains('high-contrast')){
            body.classList.remove('high-contrast');
            saveDataSession('M6_Contrast', 'contrast-off');

            customUiContraste.classList.remove('icon-sol');
            customUiContraste.classList.add('icon-luna');

            toggleRegionClass();
        }
        else{
            body.classList.add('high-contrast');
            saveDataSession('M6_Contrast', 'high-contrast');
            
            customUiContraste.classList.remove('icon-luna');
            customUiContraste.classList.add('icon-sol');
            
            removeRegionClass();
        }
    });

    // Custom UI - FullScreen
    customUiFullScreen.addEventListener('click', function(){
        customUiFullScreen.classList.add('d-none');
        customUiFullScreenExit.classList.remove('d-none');

        openFullscreen();
    });
    customUiFullScreenExit.addEventListener('click', function(){
        customUiFullScreenExit.classList.add('d-none');
        customUiFullScreen.classList.remove('d-none');

        closeFullscreen();
    });

    function openFullscreen(){
        const elem = document.documentElement;
        if (elem.requestFullscreen) {
            elem.requestFullscreen();
        } 
        else if (elem.msRequestFullscreen) {/* Safari */
            elem.msRequestFullscreen();
        } 
        else if (elem.webkitRequestFullscreen) { /* IE11 */
            elem.webkitRequestFullscreen();
        }
    }

    function closeFullscreen() {
        if (document.exitFullscreen) {
            document.exitFullscreen();
        } 
        else if (document.webkitExitFullscreen) { /* Safari */
            document.webkitExitFullscreen();
        } 
        else if (document.msExitFullscreen) { /* IE11 */
            document.msExitFullscreen();
        }
    }

    document.addEventListener("fullscreenchange", function() { 
        // console.log('fullscreen state changed');
        if(document.webkitIsFullScreen === false){
            customUiFullScreenExit.classList.add('d-none');
            customUiFullScreen.classList.remove('d-none');
        }
      
    });
}

// Validate update Menu Module
function validateMenuModule(){
    const getPath = `${getValueSession('M6_LastPathVisited')}`;
    const getModule = `${getValueSession('M6_Modulo')}`;
    const getLesson = `${getValueSession('M6_Leccion')}`;
    const getTopic = `${getValueSession('M6_Tema')}`;
    const getSubtopic = `${getValueSession('M6_Subtema')}`;

    // Get tribu value
    const getTribu = `${getValueSession('M6_Tribu')}`;

    // Components - Preimported by fetch
    const submenuRecursos = document.querySelector('#submenu-recursos');

    // Init default values to localstorage
    if(getPath === 'null' && getModule === 'null' && getLesson === 'null' && getTopic === 'null' && getSubtopic === 'null'){
        // Set path route
        saveDataSession('M6_Modulo', 'Módulo 6');
        saveDataSession('M6_Leccion', 'Inicio');
        saveDataSession('M6_Tema', 'Ninguno');
        saveDataSession('M6_Subtema', '');
    }
    // Update view to Step 0 -> Login
    else if(getTribu === ''){
        // Hide content
        navLesson.classList.add('d-none');
        submenuRecursos.classList.add('d-none');
    }
    // Update view to Step 2 -> Lesson -> Subtopic
    else if(getSubtopic !== ''){
        // Construct path url with subtopic
        const renderPath = `
        <span class="tribu-mobile d-flex d-sm-flex d-md-none">
            ${getValueSession('M6_Tribu')}
        </span>

        <span class="content">
            ${getValueSession('M6_Modulo')} 
            <span>▸</span> 
            ${getValueSession('M6_Leccion')} 
            <span>▸</span> 
            ${getValueSession('M6_Subtema')}
        <span>
        `;
        saveDataSession('M6_LastPathVisited', renderPath);
    
        const itemListModule = document.querySelector('#ruta-modulo li');
        itemListModule.innerHTML = `${getValueSession('M6_LastPathVisited')}`;
    
        navLesson.classList.remove('d-none');
        submenuRecursos.classList.remove('d-none');
    }
    // Update view to Step 1 -> Inicio
    else{
        // Construct path url without subtopic
        const renderPath = `
            <span class="tribu-mobile d-flex d-sm-flex d-md-none">
                ${getValueSession('M6_Tribu')}
            </span>
            
            <span class="content">
                ${getValueSession('M6_Modulo')} 
                <span>▸</span> 
                ${getValueSession('M6_Leccion')}
            <span>
        `;
        saveDataSession('M6_LastPathVisited', renderPath);

        const itemListModule = document.querySelector('#ruta-modulo li');
        itemListModule.innerHTML = `${getValueSession('M6_LastPathVisited')}`;

        navLesson.classList.remove('d-none');

        // submenuRecursos.classList.add('d-none');
        submenuRecursos.classList.remove('d-none');
    }
}

// Set Contrast
function setContrastRegion(){
    const contrast = `${getValueSession('M6_Contrast')}`;
    const region = `${getValueSession('M6_Region')}`;

    if(contrast === 'null' && region === 'null'){
        saveDataSession('M6_Contrast', 'contrast-off');
        saveDataSession('M6_Region', 'disabled');
    }
    else if(contrast === 'high-contrast'){
        body.classList.add(`${getValueSession('M6_Contrast')}`);
    }
    else if(step0.classList.contains('d-none')){
        toggleRegionClass();
    }
    else{
        deleteDataItem('Region');
    } 
}

// Set fontsize
function setFontSize(){
    const fontSize = `${getValueSession('M6_FontSize')}`;
    const fontSizeId = `${getValueSession('M6_FontSizeId')}`;

    if(fontSize === 'null' && fontSizeId === 'null'){
        saveDataSession('M6_FontSize', 'font-size-default');
        saveDataSession('M6_FontSizeId', 0);
    }
    
    html.className = '';
    html.classList.add(`${getValueSession('M6_FontSize')}`);

    // debugLocalStorage();
}

// Set tribu
function setTribu(){
    const tribuValue = `${getValueSession('M6_Tribu')}`;
    const tribuHead = document.querySelector('#tribu-head');

    if(tribuValue === 'null'){
        saveDataSession('M6_Tribu', '');
    } 
    else if(tribuValue === ''){
        tribuHead.classList.add('d-none');
    }
    else{
        // Tribu Head
        // Set Header Value Tribu
        tribuHead.textContent = `${getValueSession('M6_Tribu')}`;
        tribuHead.classList.remove('d-none');
    
        // debugLocalStorage();
    }

}

//BARRA DE CARGA SCROLL
// Scroll Bar - Progress
function scrollBar(){
    // Elements
    const scrollBarProgress = document.querySelector('#progress-bar');
    
    window.addEventListener('scroll', function(){
        // Position on NavLesson by scroll direction with offset
        // Offset
        let scrollTopGlobal = document.documentElement.scrollTop;
        let offsetHeader = document.querySelector('header').offsetHeight;
        let offsetNavLesson = document.querySelector('.nav-lesson').offsetHeight;

        if (scrollTopGlobal <= offsetHeader){
            // DownScroll code
            // console.log('DOWN');
            navLesson.classList.remove('component-fixed');
            step2.style.marginTop = '0px';
        } 
        else {
            // UpScroll code
            // console.log('UP');
            navLesson.classList.add('component-fixed');
            step2.style.marginTop = `${offsetNavLesson}px`;
        }
        scrollPos = scrollTopGlobal <= 0 ? 0 : scrollTopGlobal; // For Mobile or negative scrolling

        // Scroll bar progress Scipting
        let winScroll = Math.round(document.documentElement.scrollTop);
        let height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
        let scrolled = (winScroll / height) * 105;

        scrollBarProgress.style.width = scrolled + "%";
    });

}

// Scrollbar percent reset - Fixed
function resetScrollBar(){
    // Scroll Bar Progress
    const scrollBarProgress = document.querySelector('#progress-bar');

    scrollBarProgress.style.width = 0 + "%";
    window.scrollTo(0, 0);
}

// NavLesson reset - Fixed
function resetScrollElements(){
    // Nav Lesson
    navLesson.classList.remove('component-fixed');
}

// Reset Audio Speech When Load Other View
function resetAudioSpeech(){
    const customUiAudioOn = document.querySelector('#custom-ui-audio-on');
    const customUiAudioOff = document.querySelector('#custom-ui-audio-off');

    const synth = window.speechSynthesis;
    synth.cancel();
    
    customUiAudioOn.classList.add('d-none');
    customUiAudioOff.classList.remove('d-none');
}

// // Reset Carousel Lesson
// function resetCarouselsLessons(){
//     allCarouselContent.forEach(carousel => {
//         const component = new bootstrap.Carousel(carousel);
//         component.to(0);
//     });
// }

// Show transition when content loads
function viewLoaded(){
    const loaderSection = document.querySelector('.load-content');

    body.classList.add('stop-scrolling');
    loaderSection.classList.remove('loaded');

    setTimeout(() => {
        body.classList.remove('stop-scrolling');
        loaderSection.classList.add('loaded');
        // loaderSection.classList.remove('loaded');
    }, 3000);
}

// Default Carousel Controls
function defaultCarouselControls(){
    const allCarouselInner = document.querySelectorAll('.carousel-content.carousel .carousel-inner');

    // Default load
    allCarouselInner.forEach(function(carouselInner){

        let navigationPrev = document.querySelector(`#${carouselInner.parentElement.id} .control-prev`);
        let navigationNext = document.querySelector(`#${carouselInner.parentElement.id} .control-next`);
        let navigationNextLesson = document.querySelector(`#${carouselInner.parentElement.id} .control-next-lesson`);

        if(carouselInner.childElementCount < 1){
            navigationPrev.classList.add('d-none');
            navigationNext.classList.add('d-none');
            navigationNextLesson.classList.add('d-none');
        }

        else if(carouselInner.childElementCount === 1){
            navigationPrev.classList.add('d-none');
            navigationNext.classList.add('d-none');
            navigationNextLesson.classList.remove('d-none');
        }

        else if(carouselInner.childElementCount > 1){
            navigationPrev.classList.add('d-none');
            navigationNext.classList.remove('d-none');
            navigationNextLesson.classList.add('d-none');
        }

        else{
            return false;
        }
    });
}

// Calculate percent lesson viewed sync with localStorage -> StatusLesson
function calcProgress(active){
    const getLesson = `${getValueSession('M6_Leccion')}`;
    const getTopic = `${getValueSession('M6_Tema')}`;

    const progressPercent = document.querySelector('#percent-viewed');
    const paginators = document.querySelectorAll('.carousel-paginator');

    // Complete Items L1
    const itemsCompleteL1Activacion = document.querySelectorAll(`#carouselL1Activacion .carousel-inner .carousel-item[data-item-status='completo']`).length;
    const itemActiveL1Activacion = document.querySelector(`#carouselL1Activacion .carousel-inner .carousel-item.active`).dataset.itemIndex;

    const itemsCompleteL1Profundizacion = document.querySelectorAll(`#carouselL1Profundizacion .carousel-inner .carousel-item[data-item-status='completo']`).length;
    const itemActiveL1Profundizacion = document.querySelector(`#carouselL1Profundizacion .carousel-inner .carousel-item.active`).dataset.itemIndex;

    const itemsCompleteL1Dialogo = document.querySelectorAll(`#carouselL1Dialogo .carousel-inner .carousel-item[data-item-status='completo']`).length;
    const itemActiveL1Dialogo = document.querySelector(`#carouselL1Dialogo .carousel-inner .carousel-item.active`).dataset.itemIndex;

    const totalL1ItemsComplete = itemsCompleteL1Activacion + itemsCompleteL1Profundizacion + itemsCompleteL1Dialogo;

    // Complete Items L2
    const itemsCompleteL2Activacion = document.querySelectorAll(`#carouselL2Activacion .carousel-inner .carousel-item[data-item-status='completo']`).length;
    const itemActiveL2Activacion = document.querySelector(`#carouselL2Activacion .carousel-inner .carousel-item.active`).dataset.itemIndex;

    const itemsCompleteL2Profundizacion = document.querySelectorAll(`#carouselL2Profundizacion .carousel-inner .carousel-item[data-item-status='completo']`).length;
    const itemActiveL2Profundizacion = document.querySelector(`#carouselL2Profundizacion .carousel-inner .carousel-item.active`).dataset.itemIndex;

    const itemsCompleteL2Dialogo = document.querySelectorAll(`#carouselL2Dialogo .carousel-inner .carousel-item[data-item-status='completo']`).length;
    const itemActiveL2Dialogo = document.querySelector(`#carouselL2Dialogo .carousel-inner .carousel-item.active`).dataset.itemIndex;

    const totalL2ItemsComplete = itemsCompleteL2Activacion + itemsCompleteL2Profundizacion + itemsCompleteL2Dialogo;


    // Total Values
    const totalL1Items = carouselItemsL1Activacion.length + carouselItemsL1Profundizacion.length + carouselItemsL1Dialogo.length;
    const itemL1Percent = 100 / totalL1Items;

    const totalL2Items = carouselItemsL2Activacion.length + carouselItemsL2Profundizacion.length + carouselItemsL2Dialogo.length;
    const itemL2Percent = 100 / totalL2Items;

    function addPercent(current, complete){
        let currentValue = current * complete;
        let percentValue = currentValue.toFixed(0);
        return percentValue;
    }

    function setPaginator(target, total){
        paginators.forEach(item => {
            item.textContent = '[ ' + `${target} de ${total}` + ' ]';
        });
    }

    switch (getLesson) {
        case 'Lección 1':
            progressPercent.textContent = `${addPercent(itemL1Percent, totalL1ItemsComplete)}%`;

            switch (getTopic) {
                case 'l1-activacion':
                    setPaginator(itemActiveL1Activacion, carouselItemsL1Activacion.length);
                    break;
                case 'l1-profundizacion':
                    setPaginator(itemActiveL1Profundizacion, carouselItemsL1Profundizacion.length);
                    break;
                case 'l1-dialogo':
                    setPaginator(itemActiveL1Dialogo, carouselItemsL1Dialogo.length);
                    break;
                    
                default:
                    break;
            }
            break;
        case 'Lección 2':
            progressPercent.textContent = `${addPercent(itemL2Percent, totalL2ItemsComplete)}%`;

            switch (getTopic) {
                case 'l2-activacion':
                    setPaginator(itemActiveL2Activacion, carouselItemsL2Activacion.length);
                    break;
                case 'l2-profundizacion':
                    setPaginator(itemActiveL2Profundizacion, carouselItemsL2Profundizacion.length);
                    break;
                case 'l2-dialogo':
                    setPaginator(itemActiveL2Dialogo, carouselItemsL2Dialogo.length);
                    break;
                    
                default:
                    break;
            }
            break;
        default:
            break;
    }
}

// Complete single carousel -> Dialogo de saberes
function singleCarouselComplete(list){
    list.forEach(function(item){
        item.dataset.itemStatus = 'completo';
    });
}

// Validate options forms
// L1
function validateFormL1(){
    const preguntaL1_01 = document.querySelectorAll('input[name="preguntaL1_01"]');
    const preguntaL1_02 = document.querySelectorAll('input[name="preguntaL1_02"]');
    const preguntaL1_03 = document.querySelectorAll('input[name="preguntaL1_03"]');

    preguntaL1_01.forEach(function(respuesta){
        respuesta.addEventListener('click', function(){
            if(respuesta.checked){
                saveDataSession('M6_Pregunta_L1_01', 'Resuelto');
                validateLsFormL1();
            }
            else{
                return false;
            }
        });
    });

    preguntaL1_02.forEach(function(respuesta){
        respuesta.addEventListener('click', function(){
            if(respuesta.checked){
                saveDataSession('M6_Pregunta_L1_02', 'Resuelto');
                validateLsFormL1();
            }
            else{
                return false;
            }
        });
    });

    preguntaL1_03.forEach(function(respuesta){
        respuesta.addEventListener('click', function(){
            if(respuesta.checked){
                saveDataSession('M6_Pregunta_L1_03', 'Resuelto');
                validateLsFormL1();
            }
            else{
                return false;
            }
        });
    });
}

function validateLsFormL1(){
    if(
        `${getValueSession('M6_Pregunta_L1_01')}` === 'Resuelto' && 
        `${getValueSession('M6_Pregunta_L1_02')}` === 'Resuelto' && 
        `${getValueSession('M6_Pregunta_L1_03')}` === 'Resuelto'
    ){
        toggleToast('carouselL1Profundizacion');
    }
    else{
        console.log('El formulario aún no se ha completado');
        // debugLocalStorage();
    }
}

// L2
function validateFormL2(){
    const preguntaL2_01 = document.querySelectorAll('input[name="preguntaL2_01"]');
    const preguntaL2_02 = document.querySelectorAll('input[name="preguntaL2_02"]');
    const preguntaL2_03 = document.querySelectorAll('input[name="preguntaL2_03"]');

    preguntaL2_01.forEach(function(respuesta){
        respuesta.addEventListener('click', function(){
            if(respuesta.checked){
                saveDataSession('M6_Pregunta_L2_01', 'Resuelto');
                validateLsFormL2();
            }
            else{
                return false;
            }
        });
    });

    preguntaL2_02.forEach(function(respuesta){
        respuesta.addEventListener('click', function(){
            if(respuesta.checked){
                saveDataSession('M6_Pregunta_L2_02', 'Resuelto');
                validateLsFormL2();
            }
            else{
                return false;
            }
        });
    });

    preguntaL2_03.forEach(function(respuesta){
        respuesta.addEventListener('click', function(){
            if(respuesta.checked){
                saveDataSession('M6_Pregunta_L2_03', 'Resuelto');
                validateLsFormL2();
            }
            else{
                return false;
            }
        });
    });
}

function validateLsFormL2(){
    if(
        `${getValueSession('M6_Pregunta_L2_01')}` === 'Resuelto' && 
        `${getValueSession('M6_Pregunta_L2_02')}` === 'Resuelto' && 
        `${getValueSession('M6_Pregunta_L2_03')}` === 'Resuelto'
    ){
        toggleToast('carouselL2Profundizacion');
    }
    else{
        console.log('El formulario aún no se ha completado');
        // debugLocalStorage();
    }
}

// Nav Progress Scripting
function progressComponent(){
    // Template view content
    function validateCarouselPaginator(){
        function syncViewTop(){
            window.scrollTo(0, 0);
        }

        function carouselEventControl(event){
            
            let eventTargetId = document.querySelector(`#${event.target.id} .carousel-inner`);
            let childEventCount = eventTargetId.childElementCount - 1; // -1 for sincronice index with item of view
            
            let navigationPrev = document.querySelector(`#${event.target.id} .control-prev`);
            let navigationNext = document.querySelector(`#${event.target.id} .control-next`);
            let navigationNextLesson = document.querySelector(`#${event.target.id} .control-next-lesson`);
            
            if(event.to === 0){
                navigationPrev.classList.add('d-none');
                navigationNext.classList.remove('d-none');
                navigationNextLesson.classList.add('d-none');
            }
            else if(event.to >= 1 && event.to < childEventCount){
                navigationPrev.classList.remove('d-none');
                navigationNext.classList.remove('d-none');
                navigationNextLesson.classList.add('d-none');
            }
            else{
                navigationPrev.classList.remove('d-none');
                navigationNext.classList.add('d-none');
                navigationNextLesson.classList.remove('d-none');
            }
        }
        
        // Save DataProgress on LocalStorage
        function saveLessonProgress(event){
            const getLesson = `${getValueSession('M6_Leccion')}`;
            const getTopic = `${getValueSession('M6_Tema')}`;

            const eventTargetIdChildren = document.querySelectorAll(`#${event.target.id} .carousel-inner .carousel-item`);

            function completeContent(list){
                list.forEach(function(item, index){
                    if(event.to === index){

                        if(item.previousElementSibling === null){
                            item.dataset.itemStatus = 'completo';
                        }
                        else{
                            item.dataset.itemStatus = 'completo';
                            item.previousElementSibling.dataset.itemStatus = 'completo';
                        }

                        calcProgress(event.relatedTarget.dataset.itemIndex);
                    }
                });
            }

            function validateCarouselStatus(list){
                const listItems = list.length;
                const eventItems = document.querySelectorAll(`#${event.target.id} .carousel-inner .carousel-item[data-item-status='completo']`).length;
    
                if(listItems === eventItems){
                    return true;
                }
                else{
                    return false;
                }
            }

            // Carousel Lesson -> LocalStorage
            switch (getLesson) {
                case 'Lección 1':
                    switch (getTopic) {
                        case 'l1-activacion':
                            completeContent(eventTargetIdChildren);
                            if(validateCarouselStatus(eventTargetIdChildren) === true){
                                saveDataSession('M6_StatusL1Activacion', 'completado');
                                toggleToast('carouselL1Activacion');
                            }
                            break;

                        case 'l1-profundizacion':
                            completeContent(eventTargetIdChildren);
                            if(validateCarouselStatus(eventTargetIdChildren) === true){
                                saveDataSession('M6_StatusL1Profundizacion', 'completado');
                            }
                            break;

                        case 'l1-dialogo':
                            completeContent(eventTargetIdChildren);
                            if(validateCarouselStatus(eventTargetIdChildren) === true){
                                saveDataSession('M6_StatusL1Dialogo', 'completado');
                                toggleToast('carouselL1Dialogo');
                            }
                            break;
                            
                        default:
                            break;
                    }
                    break;

                case 'Lección 2':
                    switch (getTopic) {
                        case 'l2-activacion':
                            completeContent(eventTargetIdChildren);
                            if(validateCarouselStatus(eventTargetIdChildren) === true){
                                saveDataSession('M6_StatusL2Activacion', 'completado');
                                toggleToast('carouselL2Activacion');
                            }
                            break;

                        case 'l2-profundizacion':
                            completeContent(eventTargetIdChildren);
                            if(validateCarouselStatus(eventTargetIdChildren) === true){
                                saveDataSession('M6_StatusL2Profundizacion', 'completado');
                            }
                            break;

                        case 'l2-dialogo':
                            completeContent(eventTargetIdChildren);
                            if(validateCarouselStatus(eventTargetIdChildren) === true){
                                saveDataSession('M6_StatusL2Dialogo', 'completado');
                                toggleToast('carouselL2Dialogo');
                            }
                            break;
                            
                        default:
                            break;
                    }
                    break;


                default:
                    break;
            }

            // debugLocalStorage();
        }

        // Lessons Controller
        allCarouselContent.forEach(function(carousel){
            carousel.addEventListener('slid.bs.carousel', function(event){
                syncViewTop();
                carouselEventControl(event);
                saveLessonProgress(event);

                // Show Status Content Viewed on Modulo 1
                validateStatusModulo();

                // Reset Multimedia
                resetAudioSpeech();
                stopVideo();
                stopAudio();
            });
        });
    }
    validateCarouselPaginator();
}

// Toggle Header
function toggleHeader(){
    // Header
    const header = document.querySelector('#header-template');
    
    const getTopic = getValueSession('M6_Tema');
    
    if(getTopic === 'Ninguno' ){
        header.classList.remove('d-none');
    }
    else{
        header.classList.add('d-none');
    }
};

// Hide toast
function hideToast(){
    // Toast Content
    const toast = document.querySelector('#toastLesson');
    const toastInstance = new bootstrap.Collapse(toast, {
        toggle: false,
        hide: true
    });

    toastInstance.hide();
}

// Toggle toast
function toggleToast(toastActivator){
    // Toast Content
    const toast = document.querySelector('#toastLesson');
    const toastInstance = new bootstrap.Collapse(toast, {
        toggle: false,
        hide: true
    });

    const toastContent = document.querySelectorAll(`#${toast.id} .toast-actions .content-toast`);

    toastContent.forEach(function(content){
        const data = content.dataset.activator;

        if(toastActivator === data){
            content.classList.remove('d-none');
        }
        else{
            content.classList.add('d-none');
        }
    });

    
    function toastActions(){
        const carouselLastItem = document.querySelector(`#${toastActivator} .carousel-inner .carousel-item:last-of-type`); 

        if(carouselLastItem.classList.contains('active')){
            toastInstance.show();   
        }
        else{
            toastInstance.hide();
        }
    }
    toastActions();
}


// Dinamic footer
function dinamicFooter(){
    const getLesson = `${getValueSession('M6_Leccion')}`;

    // Footer Content
    const footerContentMain = document.querySelector('#footer-content-main');
    const footerContentL1 = document.querySelector('#footer-content-l1');
    const footerContentL2 = document.querySelector('#footer-content-l2');
        
    // }
    switch (getLesson) {
        case 'Lección 1':
            footerContentMain.classList.add('d-none');
            footerContentL1.classList.remove('d-none');
            footerContentL2.classList.add('d-none');
            break;

        case 'Lección 2':
            footerContentMain.classList.add('d-none');
            footerContentL1.classList.add('d-none');
            footerContentL2.classList.remove('d-none');
            break;

        case 'Lección 3':
            footerContentMain.classList.add('d-none');
            footerContentL1.classList.add('d-none');
            footerContentL2.classList.add('d-none');
            break;
    
        default:
            footerContentMain.classList.remove('d-none');
            footerContentL1.classList.add('d-none');
            footerContentL2.classList.add('d-none');
            break;
    }

    // debugLocalStorage();
}

// Function Load Dinamic Content on Template
function customContentLs(){
    const configTribu = document.querySelectorAll('.config-tribu');
    const getTribu = `${getValueSession('M6_Tribu')}`

    if(getTribu === '' || getTribu === 'null'){
        return false;
    }
    else{
        configTribu.forEach(function(tribu){
            tribu.textContent = getTribu;
        });
    }

    // debugLocalStorage();
}

// Stop Media Video
function stopVideo(){
    const videos = document.querySelectorAll('video');

    videos.forEach(function(video){
        video.pause();
    });
}

// Stop Media Audio
function stopAudio(){
    const audios = document.querySelectorAll('audio');

    audios.forEach(function(audio){
        audio.pause();
    });
}

// Break Audio and Video on modal events
function modalControl(){
    const allModal = document.querySelectorAll('.modal');
    
    allModal.forEach(function(modal){
        modal.addEventListener('shown.bs.modal', function(){
            stopVideo();
            stopAudio();
        });
        modal.addEventListener('hidden.bs.modal', function(){
            stopVideo();
            stopAudio();
        });
    });
}

// Flex Switch Content
function flexSwitchValidateL1Profundizacion(){
    const switchAM01 = document.querySelector('#flexSwitchAM01');

    const contentAM01 = document.querySelector('#contentAM01');

    switchAM01.addEventListener('click', function(){
        if(switchAM01.checked === true){
            contentAM01.classList.remove('d-none');
        }
        else{
            contentAM01.classList.add('d-none');
        }
    });
}

function flexSwitchValidateL2Profundizacion(){
    // Switch HS
    const switchHS01 = document.querySelector('#flexSwitchHS01');
    const switchHS02 = document.querySelector('#flexSwitchHS02');
    const switchHS03 = document.querySelector('#flexSwitchHS03');

    const contentHS01 = document.querySelector('#contentHS01');
    const contentHS02 = document.querySelector('#contentHS02');
    const contentHS03 = document.querySelector('#contentHS03');

    // Switch EF
    const switchEF02 = document.querySelector('#flexSwitchEF02');
    
    const modalContent01 = document.querySelector('#modal-l2-prof-18-01');
    modalContent01.addEventListener('hidden.bs.modal', function(){
        switchEF02.checked = false;
    });

    // FlexSwitch HS
    switchHS01.addEventListener('click', function(){
        if(switchHS01.checked === true){
            contentHS01.classList.remove('d-none');
        }
        else{
            contentHS01.classList.add('d-none');
        }
    });
    switchHS02.addEventListener('click', function(){
        if(switchHS02.checked === true){
            contentHS02.classList.remove('d-none');
        }
        else{
            contentHS02.classList.add('d-none');
        }
    });
    switchHS03.addEventListener('click', function(){
        if(switchHS03.checked === true){
            contentHS03.classList.remove('d-none');
        }
        else{
            contentHS03.classList.add('d-none');
        }
    });
}

// Stop Multimedia L1 Profundizacion
function controlMultimediaL1Profundizacion(){
    const switchEF01 = document.querySelector('#flexSwitchEF01');
    
    const modalContent01 = document.querySelector('#modal-l1-prof-02-01');
    
    const offcanvas01 = document.querySelector('#offcanvasL1Profundizacion01-01');
    
    modalContent01.addEventListener('hidden.bs.modal', function(){
        switchEF01.checked = false;
    });
    
    offcanvas01.addEventListener('hidden.bs.offcanvas', function(){
        stopAudio();
    });
    
    // Components control
    modalControl();
}

// Stop Multimedia L2 Profundizacion
function controlMultimediaL2Profundizacion(){
    const offcanvas02 = document.querySelector('#offcanvasL2Profundizacion14-01');
    offcanvas02.addEventListener('hidden.bs.offcanvas', function(){
        stopAudio();
    });

    const offcanvas03 = document.querySelector('#offcanvasL2Profundizacion29-01');
    offcanvas03.addEventListener('hidden.bs.offcanvas', function(){
        stopAudio();
    });

    // Modals events
    modalControl();
}


function enableTooltips(){
    // Enable tooltips
    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
    const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl));
}

function removeRegionClass(){
    body.classList.remove('region-disabled', 'region-guajira', 'region-caribe', 'region-pacifico', 'region-andina', 'region-orinoquia', 'region-amazonica');
}

function toggleRegionClass(){
    body.classList.remove('region-disabled', 'region-guajira', 'region-caribe', 'region-pacifico', 'region-andina', 'region-orinoquia', 'region-amazonica');

    body.classList.add(`${getValueSession('M6_Region')}`);
}
/****/




